import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { Button, Table } from 'reactstrap';
import { translate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { actionSetEditKit, actionDeleteKit, actionGetKitTypes } from 'store/actions/kitsActions';
import { useSelector } from 'react-redux';

//Sweet alert
import SweetAlert from "react-bootstrap-sweetalert";
import { actionSweetAlert } from "store/actions/commonActions";

const TableKits = (props) => {
    const { data, loading, page, callback } = props;
    const { t } = props;
    const { is_creating_kits } = useSelector(state => state.managementUserReducer);
    const kitTypes = useSelector(state => state.kitsReducer.types);
    const dispatch = useDispatch();
    const history = useHistory();

    const editKit = (e, kit) => {
        e.preventDefault();
        history.push(`/admin/kits/form/${kit._id}`);
    }

    const deleteKit = (e, kit) => {
        e.preventDefault();

        dispatch(
            actionSweetAlert(
                <SweetAlert
                    warning
                    title={`Are you sure you want to delete this kit?`}
                    onConfirm={() => {
                        dispatch(actionDeleteKit(kit._id));
            
                        /* Go back to the previous page if the current page has no data after deletion*/
                        if (data.length === 1 && page > 0) {
                            callback(page - 1);
                        }
            
                        dispatch(actionSweetAlert(null));
                    }}
                    onCancel={() => dispatch(actionSweetAlert(null))}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="info"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    All the data related to it will be lost!
                </SweetAlert>
            )
        );
    }

    const getOrder = (e, orderId) => {
        e.preventDefault();
        //dispatch(actionGetOrder(orderId));
        history.push(`/admin/practice-orders/form/${orderId}`);
    }

    useEffect(() => {
        if (!Object.keys(kitTypes).length) {
            dispatch(actionGetKitTypes());
        }
    }, []);


    return (
        <>

            {loading ?
                (<LoadingLocal />)
                :
                (<div className="table-data">
                    <Table>
                        <thead>
                            <tr>
                                <th> {t("friendly_id")}</th>
                                <th> {t("type")}</th>
                                <th> {t("status")}</th>
                                <th> {t("assets")}</th>
                                <th> {t("actions")} </th>
                                <th></th>
                            </tr>
                        </thead>

                        {data.length > 0 && (data.map((p, index) => {
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <th>{p.friendly_id}</th>
                                        <th>{p.type}</th>

                                        <th>
                                            {t(p.status)}
                                            {p.status === "k_st_assigned" ? (<>
                                                <p></p><a href="#" onClick={e => getOrder(e, p.practice_order_id)}>{t("see-order")}...</a>
                                            </>) : (<></>)} 
                                        </th>
                                        
                                        <th>
                                            {p.assets.map(a => {
                                                return (
                                                    <div className="table-assigned-assets" key={`av-${a._id}`}>
                                                        <small>{`${a.asset_type}(${a.brand})`}</small>
                                                    </div>
                                                )
                                            })}
                                        </th>
                                        <th>
                                            {!is_creating_kits && p.status !== "k_st_deleted"  ? (
                                                <>
                                                    <Button
                                                        onClick={e => editKit(e, p)}
                                                        className="btn-icon btn-round"
                                                        color="warning"
                                                        size="md"
                                                    >
                                                        <i className="fa fa-edit" />
                                                    </Button>

                                                    {p.status !== "k_st_assigned" ? (
                                                        <Button
                                                            onClick={e => deleteKit(e, p)}
                                                            className="btn-icon btn-round"
                                                            color="danger"
                                                            size="md"
                                                        >
                                                            <i className="fa fa-times" />
                                                        </Button>
                                                    ) : (<></>)}
                                                    
                                                </>
                                            ) : <></>}
                                            
                                        </th>
                                    </tr>
                                </tbody>
                            )
                        })
                        )}
                    </Table>
                </div>)}

        </>
    );
};
TableKits.defaultProps = {
    data: [],
    loading: true
};

TableKits.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default translate("kits")(TableKits);